// Baut den Dateinamen aus dem in den Einstellungen gespeicherten Muster
// (user.filenamePattern), spiegelt die Server-Logik in
// api/src/bafa-forms/bafa-forms.service.ts::buildFilename — damit Download,
// Server-Speicherung und BAFA-Formulare denselben Namen erzeugen.
//
// Platzhalter: {Kundenname} {Datum} {AZ} {Typ}
// Rückgabe ist der Basisname OHNE Endung; die Endung hängt der Aufrufer an.

function sanitize(s: string): string {
  return s.replace(/[^a-zA-Z0-9äöüÄÖÜß_\-]/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, '');
}

export interface ReportFilenameParts {
  kundenname?: string;
  az?: string;
  typ?: string;
  /** Basisname (ohne Endung), falls kein Muster gesetzt ist. */
  fallback: string;
}

export function buildReportFilename(pattern: string | null | undefined, parts: ReportFilenameParts): string {
  const typ = parts.typ ?? 'bericht';
  if (!pattern || !pattern.trim()) return sanitize(parts.fallback);

  const today = new Date().toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const result = pattern
    .replace(/\{Kundenname\}/g, sanitize(parts.kundenname || 'Kunde'))
    .replace(/\{Datum\}/g, today.replace(/\./g, '-'))
    .replace(/\{AZ\}/g, sanitize(parts.az || ''))
    .replace(/\{Typ\}/g, sanitize(typ));
  const name = sanitize(result);
  return name || sanitize(parts.fallback);
}
